import { makeStyles } from "@mui/styles";

// Define your styles with proper typing
export const useStyles = makeStyles((theme) => ({
  countdownText: {
    fontWeight: [300, "!important"],
    color: "black",
    textAlign: "center",
    fontSize: ["14px", "!important"],
    fontFamily: `'Avenir', sans-serif`,
  },
  countdownNumber: {
    fontWeight: [800, "!important"],
    color: "#3A3A3A",
    textAlign: "center",
    fontSize: ["14px", "!important"],
    fontFamily: `'Avenir', sans-serif`,
  },
  formContainer: {
    width: "100%",
    position: "relative",
    backgroundPosition: "top",
    backgroundSize: "cover",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
  },
  signupFormTitle: {
    textAlign: "center",
    color: "#074EDC",
    fontSize: "35px !important",
    marginTop: "20px",
  },
  formMain: {
    background: "#FFFFFF",
    maxWidth: "386px",
    width: "100%",
    minHeight: 660,
    borderRadius: 8,
    margin: "10px",
    position: "relative",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: "30px 35px",
  },
  submitButton: {
    backgroundColor: "#074EDC !important",
    color: "white !important",
    height: 44.59,
    borderRadius: "5px !important",
    textTransform: "none !important",
    fontSize: "18px !important",
    fontFamily: `'Poppins', 'Avenir', sans-serif`,
    border: "none",
    // marginTop: "200px",
  },
  submitButtonDisabled: {
    backgroundColor: "#F3F3F5 !important",
    color: "#7F8596 !important",
    height: 44.59,
    borderRadius: "5px !important",
    textTransform: "none !important",
    fontSize: "18px !important",
    fontFamily: `'Poppins', 'Avenir', sans-serif`,
    border: "1px solid #CDD1DC !important",
    // marginTop: "200px",
  },
}));
